import * as React from 'react';
import { useCalltracking } from './useCalltracking';
import { TPlaceType } from '../../types/promoDetails/callButton';

interface IMobilePhoneFetcherProps {
  placeType: TPlaceType;
}

export const MobilePhoneFetcher = ({ placeType }: IMobilePhoneFetcherProps): null => {
  const { linkPhone, responseEnded } = useCalltracking({
    placeType,
  });

  React.useEffect(() => {
    if (responseEnded) {
      window.open(linkPhone, '_self');
    }
  }, [responseEnded]);

  return null;
};
